/* Zenaliv — ofertas: reloj, copiar código y ventana de bienvenida (sin librerías) */
(function () {
  'use strict';

  function initRelojes() {
    document.querySelectorAll('[data-zl-reloj]').forEach(function (raiz) {
      if (raiz.dataset.zlListo) return;
      raiz.dataset.zlListo = '1';
      var fin = Date.parse(raiz.getAttribute('data-fin') || '');
      if (isNaN(fin)) return;
      var d = raiz.querySelector('[data-zl-d]'), h = raiz.querySelector('[data-zl-h]'),
          m = raiz.querySelector('[data-zl-m]'), s = raiz.querySelector('[data-zl-s]');
      function dos(n) { return (n < 10 ? '0' : '') + n; }
      function tic() {
        var resta = fin - Date.now();
        if (resta <= 0) {
          if (raiz.getAttribute('data-ocultar') === 'true') raiz.hidden = true;
          raiz.querySelectorAll('[data-zl-activo]').forEach(function (e) { e.hidden = true; });
          raiz.querySelectorAll('[data-zl-terminado]').forEach(function (e) { e.hidden = false; });
          return false;
        }
        var seg = Math.floor(resta / 1000);
        if (d) d.textContent = Math.floor(seg / 86400);
        if (h) h.textContent = dos(Math.floor(seg % 86400 / 3600));
        if (m) m.textContent = dos(Math.floor(seg % 3600 / 60));
        if (s) s.textContent = dos(seg % 60);
        return true;
      }
      if (tic()) { var t = setInterval(function () { if (!tic()) clearInterval(t); }, 1000); }
    });
  }

  function initCopiar() {
    document.querySelectorAll('[data-zl-copiar]').forEach(function (btn) {
      if (btn.dataset.zlListo) return;
      btn.dataset.zlListo = '1';
      btn.addEventListener('click', function () {
        var codigo = btn.getAttribute('data-zl-copiar');
        var aviso = btn.querySelector('[data-zl-copiar-texto]');
        var original = aviso ? aviso.textContent : '';
        function listo() {
          if (aviso) {
            aviso.textContent = btn.getAttribute('data-copiado') || '¡Copiado!';
            setTimeout(function () { aviso.textContent = original; }, 2000);
          }
          btn.classList.add('is-copiado');
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(codigo).then(listo, listo);
        } else {
          var tmp = document.createElement('textarea'); tmp.value = codigo; document.body.appendChild(tmp); tmp.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(tmp); listo();
        }
      });
    });
  }

  /* Una sola vez por persona; si acaba de anotarse, se abre con el código */
  function initPopup() {
    var pop = document.querySelector('[data-zl-pop]');
    if (!pop || pop.dataset.zlListo) return;
    pop.dataset.zlListo = '1';
    var CLAVE = 'zenaliv_bienvenida_vista';
    var exito = pop.querySelector('[data-zl-pop-exito]');
    function abrir() { pop.hidden = false; document.documentElement.classList.add('zl-pop-abierto'); }
    function cerrar() {
      pop.hidden = true; document.documentElement.classList.remove('zl-pop-abierto');
      try { localStorage.setItem(CLAVE, '1'); } catch (e) {}
    }
    pop.querySelectorAll('[data-zl-pop-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) cerrar(); });
    if (exito) { abrir(); return; }
    var vista = false;
    try { vista = localStorage.getItem(CLAVE) === '1'; } catch (e) {}
    if (vista || (window.Shopify && window.Shopify.designMode)) return;
    setTimeout(abrir, (parseInt(pop.getAttribute('data-retraso'), 10) || 8) * 1000);
  }

  function init() { initRelojes(); initCopiar(); initPopup(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
